export default {
  usersEndpoints: '/users',

  churchMapEndpoint: '/church-map',
  departmentsEndpoint: '/departments',
  memberStatusEndpoint: "/member-status",
  applicationsEndpoint: '/applications',
  memberTypesEndpoint: '/member-types',
  memberTitlesEndpoint: '/member-titles',
  educationEndpoint: '/education',
  userEducationEndpoint: '/user/education',
  userWorkHistoryEndpoint: '/user/work-experience',
  workHistoryEndpoint: '/work-experience',
  memberProfilesEndpoint: '/member-profiles',
  memberDesignationsEndpoint: '/member-designations',
  stationsServedEndpoint: '/stations-served',

  logsEndpoint: '/logs',
  apiEndpoint: '/api-keys',
  auditTrailEndpoint: '/audit-trail',

  searchEndpoint: '/search',
  settingsEndpoint: '/settings',
  dashboardEndpoint: '/dashboard',

  permissionsEndpoint: '/permissions',

  csvUploadsEndpoint: '/csv-uploads',
  sampleCSVFileEndpoint: '/sample-csv-file',
  exportTemplatesEndpoint: "/csv/exports/templates",
  sendgridTemplatesEndpoint: '/sendgrid/templates',
}
